import Utils from '@utils/index';

function getStreamName(stream: VideoStream): string {
  if (stream.defaultName) return stream.defaultName;
  return Utils.Stream.getIdsFromStreamName(stream.kvsName).streamId;
}

export default getStreamName;